import { render, staticRenderFns } from "./productocaracteristicaAdd.vue?vue&type=template&id=078b53f8&"
import script from "./productocaracteristicaAdd.vue?vue&type=script&lang=js&"
export * from "./productocaracteristicaAdd.vue?vue&type=script&lang=js&"
import style0 from "./productocaracteristicaAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports